namespace Cfnc {
    interface ICampusSearchFilter extends ng.IDirective {

    }

    interface ICampusSearchFilterScope extends ng.IScope {
        filterGroup: IAvaliableFiltersGroup;
        filter: IAvailableFilterOption;
        ngModel: string;
        filterGroups: IAvaliableFiltersGroup[];
        filterGroupKey: string;
    }

    class CampusSearchFilter implements ICampusSearchFilter {
        static directiveId: string = "campusSearchFilter";
        restrict: string = "A";
        scope: any = {
            ngModel: "=",
            filterGroup: "=",
            filter: "=",
            filterGroups: "=campusSearchFilter",
            filterGroupKey: "="
        };

        constructor(private $window: ng.IWindowService) {

        }

        link = (scope: ICampusSearchFilterScope, element, attrs) => {

            scope.$watch("filterGroups", (newValue: Array<any>, oldValue) => {
                //if (newValue !== oldValue) {
                if (scope.filterGroup.key !== "Sports") {
                    var index = _.findIndex(newValue,(x: any) => { return x.key == scope.filterGroup.key; });

                    if (index > -1) {
                        var value = newValue[index].filters[0].value;
                        if (scope.ngModel !== value)
                            scope.ngModel = value;
                    } else {
                        scope.ngModel = null;
                    }
                }
                //}
            }, true);

            scope.$watch("ngModel",(newValue: string) => {
                var groups = scope.filterGroups && scope.filterGroups.length > 0 ? _.filter(scope.filterGroups, { key: scope.filterGroupKey ? scope.filterGroupKey : scope.filterGroup.key }) : null;
                if (newValue && newValue !== "") {
                    scope.filter.value = newValue;
                    if (!groups || groups.length < 1) {
                        var newGroup: IAvaliableFiltersGroup = {
                            key: scope.filterGroupKey ? scope.filterGroupKey : scope.filterGroup.key,
                            category: scope.filterGroup.category,
                            filters: []
                        }

                        if (scope.filter.key === "Sport")
                            scope.filter.pillText = newValue;

                        newGroup.filters.push(_.clone(scope.filter));
                        scope.filterGroups.push(newGroup);
                    } else {
                        var group = groups[0];
                        var existingFilters = _.filter(group.filters, { key: scope.filter.key });

                        if (scope.filter.key === "Sport")
                            scope.filter.pillText = newValue;

                        if (!existingFilters || existingFilters.length < 1) {
                            group.filters.push(_.clone(scope.filter));
                        } else {
                            existingFilters[0].value = scope.filter.value;
                        }
                    }
                } else {
                    if ((groups && groups.length > 0) && scope.filter.key !== "State") {
                        var group = groups[0];

                        _.remove(group.filters, { key: scope.filter.key });

                        if (group.filters.length < 1) {
                            _.remove(scope.filterGroups, { key: group.key });
                        }
                    }
                }
            });
        };
    }

    angular.module("app").directive(CampusSearchFilter.directiveId, ["$window", $window =>
        new CampusSearchFilter($window)
    ]);
}